module.exports = __webpack_public_path__ + "static/media/emoji.b3d44b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/emoji.png
// module id = 241
// module chunks = 0